// extracted by mini-css-extract-plugin
export default {"wrapper":"main-06_wrapper__XSU+k","container":"main-06_container__USwvX","containerCard":"main-06_containerCard__fTsyf","boxCard":"main-06_boxCard__dN1F3"};